import { all, fork } from "redux-saga/effects";
import agreementSaga from "./agreements/saga";
import legalSaga from "./legal/saga";
import tutorialSaga from "./tutorials/saga";
import subscriptionsSaga from "./subscriptions/saga";
import emailSettingsSaga from "./emailSettings/saga";
import mailProvisioningSaga from "./mail-provisioning/saga";
import clientWebMailSaga from "./client-webmail/saga";
import clientLifecycleSaga from "./client-lifecycle/saga";
import assetbrandsSaga from "./asset-brands/saga";
import assetfeatureoptionsSaga from "./asset-features-options/saga";
import assetfeaturesSaga from "./asset-features/saga";
import assetgroupsSaga from "./asset-groups/saga";
import assettypesSaga from "./asset-types/saga";
import authSaga from "./auth/saga";
import brandsSaga from "./brands/saga";
import calllogstatusSaga from "./calllog-status/saga";
import contactsSaga from "./contact/saga";
import dashboardSaga from "./dashboard/saga";
import extraServiceGroupSaga from "./extra-service-group/saga";
import extraServiceSaga from "./extra-service/saga";
import fileTypesSaga from "./file-types/saga";
import reminderSubjectsSaga from "./reminder-subjects/saga";
import financialAccountTypeSaga from "./financialaccount-types/saga";
import languageSaga from "./languages/saga";
import LayoutSaga from "./layout/saga";
import maintenanceStatusesSaga from "./maintenance-status/saga";
import maintenanceTypesSaga from "./maintenance-types/saga";
import officegroupsSaga from "./officegroups/saga";
import paymentSettingsSaga from "./paymentSettings/saga";
import sectorsSaga from "./sectors/saga";
import supplierTypesSaga from "./supplier-types/saga";
import systemSaga from "./system/saga";
import taxesSaga from "./tax/saga";
import ticketSagas from "./ticket/saga";
import userSaga from "./users/saga";
import uygunaKiralaLocationsSaga from "./uygunakirala-locations/saga";
import faqsSaga from "./web-faqs/saga";
import howtouseSaga from "./web-howtouse/saga";
import packageSaga from "./web-packages/saga";
import spesificationSaga from "./web-spesifications/saga";
import contractAssetStatusSaga from "./contract-asset-status/saga";
import cancellationReasonSaga from "./contract-cancellation-reason/saga";
import damageDefinitionSaga from "./contract-damage-definition/saga";
import discountPlanSaga from "./contract-discountplans/saga";
import pickupDefinitionSaga from "./contract-pickup-definition/saga";
import contractSourceSaga from "./contract-sources/saga";
import contractStatusSaga from "./contract-status/saga";
import contractTransactionTypeSaga from "./contract-transaction-type/saga";
import contractTypeSaga from "./contract-type/saga";
import clientOnboardingSaga from "./client-onboarding/saga";
import ontologySaga from "./ontology/saga";
import systemStatusSaga from "./system-status/saga";
import trustSaga from "./trust/saga";
import clientSaga from "./clients/saga";
import testimonialsSaga from "./testimonials/saga";
import adminclientcancellationreasonsSaga from "./clientcancelreason/saga";
import BankAccountSaga from "./bankaccounts/saga";
import marketingV2Saga from "./marketing-v2/saga";

export default function* rootSaga() {
  yield all([
    //public
    fork(LayoutSaga),
    ...authSaga,
    ...languageSaga,
    ...userSaga,

    //WEB
    ...faqsSaga,
    ...howtouseSaga,
    ...packageSaga,
    ...spesificationSaga,
    ...systemSaga,
    ...calllogstatusSaga,
    ...extraServiceSaga,
    ...extraServiceGroupSaga,
    ...fileTypesSaga,
    ...reminderSubjectsSaga,
    ...financialAccountTypeSaga,
    ...maintenanceStatusesSaga,
    ...maintenanceTypesSaga,
    ...supplierTypesSaga,
    ...taxesSaga,
    ...paymentSettingsSaga,
    ...ticketSagas,
    ...agreementSaga,
    ...legalSaga,
    ...tutorialSaga,
    ...subscriptionsSaga,
    ...emailSettingsSaga,
    ...mailProvisioningSaga,
    ...clientWebMailSaga,
    ...clientLifecycleSaga,
    ...assetbrandsSaga,
    ...assettypesSaga,
    ...assetfeaturesSaga,
    ...assetfeatureoptionsSaga,
    ...assetgroupsSaga,
    ...brandsSaga,
    ...contactsSaga,
    ...officegroupsSaga,
    ...uygunaKiralaLocationsSaga,
    ...sectorsSaga,
    ...dashboardSaga,

    ...contractAssetStatusSaga,
    ...cancellationReasonSaga,
    ...damageDefinitionSaga,
    ...discountPlanSaga,
    ...pickupDefinitionSaga,
    ...contractSourceSaga,
    ...contractStatusSaga,
    ...contractTransactionTypeSaga,
    ...contractTypeSaga,
    ...clientSaga,
    ...clientOnboardingSaga,
    ...ontologySaga,
    ...trustSaga,
    ...systemStatusSaga,
    ...testimonialsSaga,
    ...adminclientcancellationreasonsSaga,
    ...BankAccountSaga,
    ...marketingV2Saga,
  ]);
}
